import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Divider } from '../Divider';
import { TextButton } from '../TextButton';
import styles from './MenuContextualAction.module.scss';
export function MenuContextualAction(param) {
    let { title: text, intent, testId, icon, onClick, bi } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                margin: 0
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                bi: bi,
                underline: "none",
                weight: "normal",
                className: styles.root,
                intent: intent,
                testId: testId,
                prefixIcon: icon,
                onClick: onClick,
                children: text
            })
        ]
    });
}
